module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc_entry",
    attrs: {
      "id": "page_iii"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry1"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/text/part0003#page_1"
    }
  }, [_vm._v("Preface: “God Loves You and Has a Wonderful Plan For Your Life”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry1"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/text/part0004#page_6"
    }
  }, [_vm._v("Introduction: Progressions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry2"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/text/part0005#page_12"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" I—G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SSENTIAL")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EING AND")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TERNAL")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry3"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/text/part0006#page_14"
    }
  }, [_vm._v("Day 1—The Nature and Character of God")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry3"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/text/part0007#page_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 2—God’s Eternal Plan and Purpose"), _c('br', {
    staticClass: "calibre6"
  }), _vm._v("\nFor His Created Universe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/text/part0008#page_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" II—G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAN")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OR")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANKIND")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry3"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/text/part0009#page_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 3—God’s Plan For Mankind: General Principles and Universal Commands")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry3"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/text/part0010#page_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 4—God’s Plan For Mankind: Specific Commands")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry4"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/text/part0011#page_86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" III—G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAN")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OR")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OU")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry3"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/text/part0012#page_88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 5—God’s Revealed Will Through Scripture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry3"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/text/part0013#page_96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 6— God’s Revealed Will Through the Holy Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry3"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/text/part0014#page_108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 7— God’s Revealed Will Through Wise Counselors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry5"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/text/part0015#page_115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword—Concluding Perspectives")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry6"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/text/part0016#page_120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Devotional Prayer and Study Guide")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54559bd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0002.vue
// module id = 66
// module chunks = 0